module.exports = new __parcel__URL__("otter.1b9e17fe.svg").toString();